export class PLATIMATICQuestionnaire {
    constructor(
        public OfferID?: Number,
        public Firstname?: String,
        public Lastname?: String,
        public Address?: String,
        public PostalCode?: String,
        public Settlement?: String,
        public JMBG?: String,
        public Bank?: String,
        public AccountNumber?: String,
        public BIC?: String,
        public ContractNumber?: String,
        public Currency?: Number,
        public FirstMandateFrom?: String,
        public FirstMandateTo?: String,
        public SecondMandateFrom?: String,
        public SecondMandateTo?: String) { }
}